import { type ApiClientResponse, apiClient, routes } from 'common/services';

export type UpdateNotificationSettingRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  notifications: {
    badge_notifications_settings: {
      enable_notifications: boolean;
    };
    email_notifications_settings: {
      enable_notifications: boolean;
      events: boolean;
      giving: boolean;
      newsfeed: boolean;
      program: boolean;
    };
    push_notifications_settings: {
      enable_notifications: boolean;
      events: boolean;
      giving: boolean;
      messaging: boolean;
      newsfeed: boolean;
      program: boolean;
    };
  };
  userId: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const updateNotificationsSettings = async ({ notifications, userId }: UpdateNotificationSettingRequest) => {
  const updateUser = {
    user: {
      ...notifications,
    },
  };

  return apiClient.patch<unknown, ApiClientResponse<unknown>>(routes.user.patch(userId), updateUser);
};
